import { type DealQueueSort, type DealQueueTab } from '@carsfinders/contracts';
import { useState } from 'react';

import { DealsBoard } from '../../deals/components/deals-board';
import { DEFAULT_DEALS_SORT } from '../../deals/deals-page';
import { type User } from '../types';

/**
 * «Ставки» tab — this client's lots, drawn exactly like «Угоди» (owner,
 * 2026-10-12: «відображай їх так само як на сторінці угод»): the same
 * «Активні / Завершені» tabs, «Етап» and sort filters, the same rows with the
 * auction close, the stage and the ONE next action — mirror, outcome (locked
 * until the real auction ends), invoice. It IS the «Угоди» board, scoped to
 * the client by `userId` on `GET /api/admin/deals/queue`.
 *
 * The tab and the order are local state, not the URL: the client page's own
 * `?tab=` already names WHICH client tab is open.
 *
 * Like «Угоди», an outbid bid is not listed (nothing for the operator to do,
 * the amount is free again) and a lost one only for 30 days — the queue's
 * source rule, not this tab's.
 */
export function ClientBidsTab({ user }: { user: User }) {
  const [tab, setTab] = useState<DealQueueTab>('active');
  const [sort, setSort] = useState<DealQueueSort>(DEFAULT_DEALS_SORT);

  return (
    <div className="flex flex-col gap-4" data-testid="client-bids-board">
      <DealsBoard
        tab={tab}
        sort={sort}
        onTabChange={setTab}
        onSortChange={setSort}
        userId={user._id}
      />
    </div>
  );
}
